var $b423649b5cbc9dc3$exports = {};
$b423649b5cbc9dc3$exports = {
    "collapse": `Comprimi`,
    "expand": `Espandi`
};


export {$b423649b5cbc9dc3$exports as default};
//# sourceMappingURL=it-IT.module.js.map
